export default "__VITE_ASSET__NTohuIIi__"